import stringUtil from '@/utils/modules/utils.stringutil.js';
export default {
  getDateByStringDate: function(selectedDate){ // 입력받은 문자열 날짜를 Date형 날짜로 리턴함.
    var y = selectedDate.substr(0,4);
    var m = selectedDate.substr(4,2);
    var d = selectedDate.substr(6,2);
    var digitM = m - 1;
    // console.log("y:" + y);
    // console.log("m:" + m);
    // console.log("d:" + d);
    // console.log("digitM:" + digitM);
    // console.log("-------------------------------");
    
    // 선택한 날. 요일
    var dateAsDateType = new Date(y,digitM,d);

    return dateAsDateType;
  },
  calculateMonthDateArray: function (selectedMon) {
    var weekStartDate = this.getMonthStart(selectedMon); // 넘긴 월(문자열)의 첫날이 속한 주의 첫날 조회.
    var stringLastDayOfMon = this.getLastDayOfMon(selectedMon); // 넘긴 월(문자열)의 마지막날   
    var arrayDate = this.getMonthDateArray(weekStartDate,stringLastDayOfMon); // 넘긴 날짜(Date type)로 시작하는 해당월의 날짜 배열 조회.
    
    return arrayDate;
  },
	getMonthStart: function (selectedMon) { // 넘어온 월(문자열)의 첫날이 속한 주의 첫날 조회.
    var y = selectedMon.substr(0,4);
    var m = selectedMon.substr(4,2);
    var digitM = m - 1;
    // console.log("y:" + y);
    // console.log("m:" + m);
    // console.log("digitM:" + digitM);
    // console.log("-------------------------------");
    
    // 선택한 달의 첫날. 요일
    var firstDayOfMon = new Date(y,digitM,1);
    var dowOfFirstDayOfMon = firstDayOfMon.getDay();
    // console.log("firstDayOfMon:" + firstDayOfMon);
    // console.log("dowOfFirstDayOfMon:" + dowOfFirstDayOfMon);
    // console.log("-------------------------------");
    
    // 선택한 달의 첫날의 같은 주 첫날이 몇일인지.			
    var weekStartDate = new Date(new Date(firstDayOfMon).setDate(firstDayOfMon.getDate() - dowOfFirstDayOfMon));    
    // console.log("weekStartDate:" + weekStartDate);
    // console.log("-------------------------------");
    return weekStartDate;
	},
  getLastDayOfMon: function(selectedMon){ // 넘어온 월(문자열)의 마지막날   
    var y = selectedMon.substr(0,4);
    var m = selectedMon.substr(4,2); 
    var lastDayOfMon = new Date(y, m, 0);
    
    //console.log("getLastDayOfMon lastDayOfMon11:" + lastDayOfMon);

    var stringLastDayOfMon = lastDayOfMon.getFullYear() + stringUtil.pad(lastDayOfMon.getMonth()+1) + stringUtil.pad(lastDayOfMon.getDate());
    //  console.log("lastDayOfMon:" + lastDayOfMon);
    //  console.log("-------------------------------");

    return stringLastDayOfMon;
  },
	getMonthDateArray: function (weekStartDate,stringLastDayOfMon) { // 넘어온 날짜(Date type)로 시작하는 해당월의 날짜 배열 조회.  
    // console.log("getMonthDateArray weekStartDate:" + weekStartDate);
    // console.log("getMonthDateArray stringLastDayOfMon:" + stringLastDayOfMon);
    // console.log("-------------------------------");

    var isEndDay = false; // 마지막날까지 담았는지.
    var arrayDate = new Array();
    var weekDate = new Date();
    var remain = 0;
    
    for(let i=0; i <42; i++){ // 최대 6줄 * 7일 = 42일. (28일 ~ 42일)
      weekDate = new Date(new Date(weekStartDate).setDate(weekStartDate.getDate() + i));  

      arrayDate[i] = weekDate.getFullYear() + stringUtil.pad(weekDate.getMonth() + 1) + stringUtil.pad(weekDate.getDate());
      
      //console.log("getMonthDateArray stringLastDayOfMon:" + stringLastDayOfMon + ",arrayDate[i]:"+arrayDate[i]);
      if(stringLastDayOfMon == arrayDate[i]) { // 생성한 날짜가 마지막날짜와 같으면 true.
        isEndDay = true;
      }
      remain = i%7;
    
      // console.log("getMonthDateArray isEndDay:" + isEndDay);
      // console.log("getMonthDateArray remain:" + remain);
      if(isEndDay && remain == 6){ // 말일까지 찍고, 토요일이면 끝!
        break;
      }
    }
    
    // console.log("arrayDate:" + arrayDate);
    // console.log("-------------------------------");
    return arrayDate;
	},
	getWeekStart: function (selectedDate) { // 넘어온 날짜(문자열)가 속한 주의 첫날 조회.
    // 선택한 날. 요일
    var selectedDateAsDateType = this.getDateByStringDate(selectedDate);
    var dowOfSelectedDateAsDateType = selectedDateAsDateType.getDay();
    // console.log("selectedDateAsDateType:" + selectedDateAsDateType);
    // console.log("dowOfSelectedDateAsDateType:" + dowOfSelectedDateAsDateType);
    // console.log("-------------------------------");    
    
    // 선택한 날의 같은 주 첫날이 몇일인지.			
    var weekStartDate = new Date(new Date(selectedDateAsDateType).setDate(selectedDateAsDateType.getDate() - dowOfSelectedDateAsDateType));    
    // console.log("weekStartDate:" + weekStartDate);
    // console.log("-------------------------------");
    return weekStartDate;
	},
	getWeekStartByWeekNum: function (year, mon, weekNum) {// 넘어온 년도, 월, 주 차수의 첫날 조회.
		// console.log("year:"+year);    
		// console.log("mon:"+mon);
		// console.log("weekNum:"+weekNum);
		
		var firstDayOfMon = new Date(year,mon-1,1);
		var dowOfFirstDayOfMon = firstDayOfMon.getDay();
		// console.log("firstDayOfMon:" + firstDayOfMon);
		// console.log("dowOfFirstDayOfMon:" + dowOfFirstDayOfMon);
		
		// 주차 * 7 + 그달의 첫날의 요일.
		var daynum = (weekNum - 1) * 7 - dowOfFirstDayOfMon;

		var weekStartDate = new Date(new Date(firstDayOfMon).setDate(firstDayOfMon.getDate() + daynum));  
		// console.log("weekStartDate:" + weekStartDate);
		// console.log("-------------------------------");

		return weekStartDate;
	},
	getWeekDateArray: function (weekStartDate) { // 넘어온 날짜(Date type)로 시작하는 7일 날짜 배열 조회.
    var arrayDate = new Array();
    
    for(let i=0; i <7; i++){
      var weekDate = new Date(new Date(weekStartDate).setDate(weekStartDate.getDate() + i));
      
      arrayDate[i] = weekDate.getFullYear() + stringUtil.pad(weekDate.getMonth() + 1) + stringUtil.pad(weekDate.getDate());
    }
    
    // console.log("arrayDate:" + arrayDate);
    // console.log("-------------------------------");
    return arrayDate;
	},
  getSelectedWeekNum: function(selectedDateAsDateType){ // 넘어온 날짜(Date type)가 속한 주의 달에서의 차수.
    var y = selectedDateAsDateType.getFullYear();
    var m = selectedDateAsDateType.getMonth();

    // 선택한 날이 속한 달의 첫날
    var firstDayOfMon = new Date(y,m,1);
    var dowOfFirstDayOfMon = firstDayOfMon.getDay();
    // console.log("firstDayOfMon:" + firstDayOfMon);
    // console.log("dowOfFirstDayOfMon:" + dowOfFirstDayOfMon);
    // console.log("-------------------------------");
        
    // 선택한 날이 몇일차인지.
    var daynum = Math.floor((selectedDateAsDateType.getTime() - firstDayOfMon.getTime())/86400000) + 1;
    // console.log("firstDayOfMon.getTime():" + firstDayOfMon.getTime());
    // console.log("selectedDateAsDateType.getTime():" + selectedDateAsDateType.getTime());
    // console.log("daynum:" + daynum);
    // console.log("-------------------------------");
    
    // 선택한 날이 몇주차인지.
    var weeknum = Math.floor( ( daynum + dowOfFirstDayOfMon - 1 )/7 ) + 1;
    // console.log("weeknum:" + weeknum);
    // console.log("-------------------------------");

    return weeknum;
  },
  getTotalWeekNum: function(selectedDateAsDateType){ // 넘어온 날짜(Date type)가 속한 달의 주 카운트.
    var y = selectedDateAsDateType.getFullYear();
    var m = selectedDateAsDateType.getMonth();
    
    // 선택한 날이 속한 달의 첫날
    var firstDayOfMon = new Date(y,m,1);
    var dowOfFirstDayOfMon = firstDayOfMon.getDay();
    // console.log("firstDayOfMon:" + firstDayOfMon);
    // console.log("dowOfFirstDayOfMon:" + dowOfFirstDayOfMon);
    // console.log("-------------------------------");

    // 선택한 날이 속한 달의 마지막날
    var lastDayOfMon = new Date(y, (m*1) + 1, 0);
    // console.log("lastDayOfMon:" + lastDayOfMon);
    // console.log("-------------------------------");
    
    // 마지막날이 몇일차인지.
    var daynum = Math.floor((lastDayOfMon.getTime() - firstDayOfMon.getTime())/86400000) + 1;
    // console.log("daynum:" + daynum);
    // console.log("-------------------------------");
    
    // 마지막날이 몇주차인지.
    var weeknum = Math.floor( ( daynum + dowOfFirstDayOfMon - 1 )/7 ) + 1;
    // console.log("weeknum:" + weeknum);
    // console.log("-------------------------------");

    return weeknum;
  },
  getAge: function(stringDate){ // 만나이 계산
    
      var da1 = this.getDateByStringDate(stringDate);// 입력받은 문자열 날짜를 Date형 날짜로 리턴함.
      var da2 = new Date();
      var dif = da2 - da1;
      var cDay = 24 * 60 * 60 * 1000;// 시 * 분 * 초 * 밀리세컨
      var cMonth = cDay * 30;// 월 만듬
      var cYear = cMonth * 12; // 년 만듬
      var age = parseInt(dif/cYear);
      var ageMon  = parseInt(dif/cMonth);
      var result = age + "세";
      if(age < 5){
        result = result + "(" + ageMon + "개월)";
      }
      
      return result;
  },
  getAge2: function(stringDate){ // 한국나이 계산
    
      var y = stringDate.substr(0,4);
    
      var da1 = this.getDateByStringDate(stringDate);// 입력받은 문자열 날짜를 Date형 날짜로 리턴함.
      var da2 = new Date();
      var nowYear = da2.getFullYear();
      var age = nowYear - y + 1;

      var dif = da2 - da1;
      var cDay = 24 * 60 * 60 * 1000;// 시 * 분 * 초 * 밀리세컨
      var cMonth = cDay * 30;// 월 만듬
      var ageMon  = parseInt(dif/cMonth);
      
      var result = age + "세";
      if(age < 5){
        result = result + "(" + ageMon + "개월)";
      }
      
      return result;
  },
  isBirthday: function (dateStr) { 
    var year = Number(dateStr.substr(0,4)); // 입력한 값의 0~4자리까지 (연) 
    var month = Number(dateStr.substr(4,2)); // 입력한 값의 4번째 자리부터 2자리 숫자 (월) 
    var day = Number(dateStr.substr(6,2)); // 입력한 값 6번째 자리부터 2자리 숫자 (일) 
    var today = new Date(); // 날짜 변수 선언 
    var yearNow = today.getFullYear(); // 올해 연도 가져옴 
    if (dateStr.length <=8) { // 연도의 경우 1900 보다 작거나 yearNow 보다 크다면 false를 반환합니다. 
      if (1900 > year || year > yearNow){ 
        return false; 
      } else if (month < 1 || month > 12) { 
        return false; 
      } else if (day < 1 || day > 31) { 
        return false; 
      } else if ((month==4 || month==6 || month==9 || month==11) && day==31) { 
        return false; 
      } else if (month == 2) { 
        var isleap = (year % 4 == 0 && (year % 100 != 0 || year % 400 == 0)); 
        if (day>29 || (day==29 && !isleap)) { 
          return false; 
        } else { 
          return true; 
        } //end of if (day>29 || (day==29 && !isleap)) 
      } else { 
        return true; 
      }//end of if 
    } else { //1.입력된 생년월일이 8자 초과할때 : auth:false 
      return false; 
    } 
  }
  
}
